import React from "react";
import themePropTypes from "../theme-prop-types";

const Label = ({
  name,
  labelId,
  inputId,
  text,
  isRequired,
  params = "",
  invalid,
  children,
  size,
  appData,
  srLabel
}) => {
  const { required_field } = appData?.settings?.translations || {};

  // TODO: remove const below after adding all asterisks to required fields on be
  const hardcodedAsterisk = isRequired && !text.includes("*") ? "*" : "";
  const asteriskToRender = isRequired &&
    !params.includes("TDFieldOptionHideAsterisk") && (
      <>
        {/* TODO: remove line below after adding all asterisks to required fields on be */}
        {hardcodedAsterisk && (
          <span aria-hidden='true'>{hardcodedAsterisk}</span>
        )}
      </>
    );

  const textToRender = srLabel ? (
    <span aria-hidden={isRequired}>{text}</span>
  ) : (
    text
  );

  return (
    <label
      className={`label-web-sdk label-${size}-web-sdk ${
        params ? params.split("|").join(" ") : ""
      } ${invalid ? "invalid" : ""}`}
      htmlFor={inputId || `${name}-input`}
      data-testid={(name && `label-${name}`) || labelId}
    >
      <span id={labelId || `${name}-label`} className='label-title-websdk'>
        {textToRender}
        {asteriskToRender}
        {isRequired && (
          <span className='websdk-sr-only'>{`
            , ${srLabel || required_field} 
          `}</span>
        )}
      </span>
      {children}
    </label>
  );
};

Label.propTypes = themePropTypes.label;

export default Label;
